import {Component} from '@angular/core';

@Component({
    selector: 'vui-panel-content',
    templateUrl: './panel-content.component.html'
})
export class PanelContentComponent {

}
